module.exports = __webpack_public_path__ + "img/portraits_15_H.0dedd952.webp";